import styled, { createGlobalStyle } from 'styled-components';
import { Modal } from 'antd';
import { vars, pxToRem, media } from '$util/theme';
import { getBreakpoint } from '$util/theme/breakpoints';

export const GlobalStyle = createGlobalStyle`
  .fixter-deprecated-modal-wrap {
    overflow: hidden;
  }
  .fixter-deprecated-modal-wrap-with-footer {
    overflow: hidden;
    .ant-modal-body {
      max-height: calc(100vh - 160px) !important;
      @media (min-width: ${getBreakpoint('md')}) {
        max-height: calc(90vh - 174px) !important;
      }
    }
    .ant-modal-footer {
      height: 80px;
      display: flex;
      justify-content: center;
      align-items: center;
      button {
        font-size: ${pxToRem(14)};
        font-weight: ${vars.fontWeight.semiBold};
        white-space: nowrap;
        span {
          margin: auto;
        }
        div{
          justify-content: center;
        }
      }
      .Image {
        margin-right: 2px;
      }
    }
  }
`;

export default styled(Modal)`
  &.ant-modal {
    min-width: 100vw;
    height: 100%;
    margin: 0;
    padding: 0;
    ${media.up('md')} {
      min-width: 550px;
      height: auto;
    }
    .ant-modal-content {
      height: 100vh; /* Fallback */
      height: -moz-available; /* Firefox */
      height: -webkit-fill-available; /* Chrome, Safari */
      height: fill-available;
      border-radius: 0;
      ${media.up('md')} {
        height: auto;
        max-height: 90vh;
        border-radius: ${vars.defaultBorderRadius};
      }
    }
    .ant-modal-header {
      padding-top: 24px;
      padding-bottom: 24px;
      border-radius: 0;
      border-bottom: 0 !important;
      ${media.up('md')} {
        background-color: unset;
        border: none;
        padding-top: 29px;
        padding-bottom: 29px;
        border-radius: ${vars.defaultBorderRadius} ${vars.defaultBorderRadius} 0 0;
      }
      .ant-modal-title {
        &,
        p {
          font-family: Jokker;
          color: ${vars.quantumverse.reskinColors.neutral800} !important;
          font-size: ${pxToRem(22)};
          line-height: ${pxToRem(28)};
          font-weight: ${vars.fontWeight.semiBold} !important;
          text-align: center;

          ${media.up('md')} {
            font-size: ${pxToRem(28)};
            margin-top: 0;
          }
        }
      }
    }
    .ant-modal-body {
      padding-top: 15px;
      max-height: calc(100vh - 200px);
      overflow-y: auto;
      font-family: Rubik;
      color: ${vars.quantumverse.reskinColors.neutral700};
      ${media.up('md')} {
        max-height: calc(90vh - 80px);
        padding-top: 0;
      }
    }
  }
`;
